import NumberLoading from"@wp/src/components/common/NumberLoading";import styled from"@emotion/styled";export const CurrencyNumberLoading=styled(NumberLoading)`
  display: inline;
`;